export const CONTENT_IMAGE = 'CONTENT_IMAGE'
export const STYLE_IMAGE = 'STYLE_IMAGE'
export const MANIPULATOR = 'MANIPULATOR'
